import React, { useContext, useEffect,useState } from "react";
import languageMenuIcon from "../assets/wap/language_menu_icon.svg";
import { useLanguage } from "../Context/LangContext";

function SwitchLanguageDropdown({homeLogo}) {
    const {language}=useLanguage();
  const [lang,setLang] = useState([])
console.log("::::::::HOME LOGO UREL::::::::::", homeLogo)

  useEffect(() => {
    setLang(language);
  },[])

  function handleLangSwitch(event) {
    const language = event.target.value;
    if(localStorage.getItem("selectedLang1") !== language) {
        localStorage.setItem("selectedLang1",language);
        window.location.reload();

    }

  }

  return (
    <>
    <div className="flex flex-col pr-3 my-2 switch-menu-lang-drop">
      <div>
      <img src={homeLogo} className="home-logo-switch-menu" styles="my-1 float-left" />
      </div>
      <div className="ml-auto mr-0 ml-auto mr-0 align-center items-center">
        {/* <img src={languageMenuIcon} className="pr-2" styles="my-4 w-1/2 "/> */}
        <select
          onChange={handleLangSwitch}
          className="switch-language-dropdown flexshadow appearance-none border-2 text-center h-10 leading-loose focus:outline-none focus:shadow-outline"
        >
          <option value="en" selected={lang === 'en'}>English</option>
          <option value="ar" selected={lang === 'ar'}>Arabic</option>
        </select>
      </div>
    </div>
    </>
  );
}

export default SwitchLanguageDropdown;
